import React from 'react';
import { CalendarToolbarV1 } from './calendar-toolbar-v1';
import { CalendarToolbarV2 } from './calendar-toolbar-v2';
import { ICalendarToolbarProps } from './calendar-toolbar-types';

export function CalendarToolbar(props: ICalendarToolbarProps) {
  const { toolbarVariant = 'v1' } = props;

  if (toolbarVariant === 'v1') {
    return <CalendarToolbarV1 {...props} />;
  }

  return <CalendarToolbarV2 {...props} />;
}
